import React from "react";
import MainHeader from "../components/serviceSection/MainHeader";
import HowItWork from "../components/serviceSection/MainSection";
import "../components/serviceSection/page.css";

const services = () => {
  return (
    <div className="service_section">
        <MainHeader />
        <HowItWork />
    </div>
  )
};

export default services;
